export const navLinks = [
  { id: "download", label: "下载方式" },
  { id: "features", label: "功能亮点" },
  { id: "versions", label: "版本对比" },
  { id: "requirements", label: "配置要求" },
  { id: "guide", label: "安装教程" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { label: "当前版本", value: "v3.8.2" },
  { label: "最近更新", value: "2026-09-28" },
  { label: "支持系统", value: "Android / iOS" },
];

export const downloadOptions = [
  {
    key: "android",
    name: "安卓版",
    platform: "Android 5.0 及以上",
    version: "v3.8.2",
    size: "约 42 MB",
    updated: "2026-09-28",
    icon: "ri-android-line",
    desc: "适用于绝大多数安卓手机与平板，直接下载安装包即可使用，不依赖应用商店，安装更灵活。",
    points: ["安装包体积小", "支持离线缓存整卷", "适配大屏横屏阅读"],
    featured: true,
  },
  {
    key: "ios",
    name: "iOS 版",
    platform: "iOS 13.0 及以上",
    version: "v3.8.1",
    size: "约 186 MB",
    updated: "2026-09-25",
    icon: "ri-apple-line",
    desc: "面向 iPhone 与 iPad，通过应用商店渠道安装，系统自动更新，无需手动管理版本。",
    points: ["商店渠道分发", "自动更新省心", "针对 iPad 优化排版"],
    featured: false,
  },
  {
    key: "latest",
    name: "最新版（通用）",
    platform: "自动识别设备",
    version: "v3.8.2",
    size: "聚合入口",
    updated: "2026-09-28",
    icon: "ri-download-cloud-2-line",
    desc: "汇总当前最新版本号，按你使用的设备推荐合适安装包，省去逐个版本查找与比对的麻烦。",
    points: ["自动匹配系统", "版本信息实时同步", "适合初次安装用户"],
    featured: false,
  },
];

export const features = [
  {
    icon: "ri-book-shelf-line",
    title: "海量漫画资源",
    desc: "涵盖热血、恋爱、奇幻、悬疑、日常等多种题材，分类齐全，内容持续更新。",
  },
  {
    icon: "ri-download-2-line",
    title: "离线缓存阅读",
    desc: "提前缓存整卷章节，地铁、飞机等无网络环境下也能顺畅追更，不打断阅读节奏。",
  },
  {
    icon: "ri-device-line",
    title: "多端进度同步",
    desc: "手机与平板登录同一账号后自动同步书架与进度，换设备也能从上次那一页继续。",
  },
  {
    icon: "ri-moon-clear-line",
    title: "夜间护眼模式",
    desc: "提供多档亮度与暖色滤镜，深夜阅读时减少屏幕刺激，长时间观看更舒适。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "智能书签与历史",
    desc: "自动记录阅读位置，支持按作品分组管理，随时回到上次读到的地方。",
  },
  {
    icon: "ri-speed-up-line",
    title: "流畅翻页引擎",
    desc: "纵向滚动、翻页、双页三种模式自由切换，页面预加载更快，画面不再卡顿。",
  },
  {
    icon: "ri-sparkling-line",
    title: "个性化推荐",
    desc: "根据阅读偏好在首页生成推荐清单，减少盲目查找，更容易发现合口味的作品。",
  },
  {
    icon: "ri-eye-line",
    title: "纯净阅读体验",
    desc: "界面简洁、层级清晰，减少无关干扰，让你把注意力放回漫画内容本身。",
  },
];

export const versionColumns = ["对比项", "安卓版", "iOS 版", "平板版"];

export const versionRows = [
  ["系统要求", "Android 5.0 及以上", "iOS 13.0 及以上", "Android / iPadOS"],
  ["安装方式", "安装包手动安装", "应用商店安装", "对应商店安装"],
  ["安装包大小", "约 42 MB", "约 186 MB", "约 160 MB"],
  ["离线缓存", "支持", "支持", "支持，大屏更佳"],
  ["夜间模式", "支持", "支持", "支持"],
  ["更新方式", "手动更新", "商店自动更新", "商店自动更新"],
  ["阅读模式", "翻页 / 滚动 / 双页", "翻页 / 滚动 / 双页", "双页 / 横屏优化"],
];

export const requirementTabs = [
  {
    key: "android",
    label: "安卓设备",
    icon: "ri-android-line",
    items: [
      { title: "系统版本", desc: "Android 5.0（API 21）及以上，主流定制系统均可运行。" },
      { title: "运行内存", desc: "2 GB 及以上，建议 4 GB 以获得更流畅的翻页体验。" },
      { title: "存储空间", desc: "至少预留 200 MB；开启离线缓存建议预留 2 GB 以上。" },
      { title: "处理器", desc: "主流 ARM 架构芯片均可正常使用。" },
      { title: "网络环境", desc: "首次登录建议在 Wi-Fi 环境完成，日常阅读 4G/5G 也可。" },
    ],
  },
  {
    key: "ios",
    label: "iPhone / iPad",
    icon: "ri-apple-line",
    items: [
      { title: "系统版本", desc: "iOS 13.0 / iPadOS 13.0 及以上。" },
      { title: "支持设备", desc: "iPhone 6s 及更新机型，iPad（2017 年及更新款）。" },
      { title: "存储空间", desc: "至少预留 300 MB，缓存较多内容时建议预留更多空间。" },
      { title: "网络环境", desc: "支持 4G / 5G 与 Wi-Fi，缓存建议使用 Wi-Fi。" },
      { title: "账号登录", desc: "需要 Apple ID 或官方账号，用于同步书架与进度。" },
    ],
  },
];

export const installSteps = [
  {
    step: "01",
    icon: "ri-search-eye-line",
    title: "确认你的设备型号",
    desc: "先查看手机或平板的系统版本，再对照页面上方的配置要求，确认可以正常安装。",
  },
  {
    step: "02",
    icon: "ri-download-line",
    title: "选择并下载对应版本",
    desc: "安卓用户下载安装包，iPhone 与 iPad 用户走应用商店渠道，点击对应按钮等待下载完成。",
  },
  {
    step: "03",
    icon: "ri-shield-check-line",
    title: "完成安装与安全授权",
    desc: "安卓设备需在系统设置中允许当前来源安装应用；iOS 按系统提示完成安装即可。",
  },
  {
    step: "04",
    icon: "ri-play-circle-line",
    title: "登录并开始阅读",
    desc: "打开应用登录账号，书架与阅读进度会自动同步，随后即可浏览或缓存喜欢的作品。",
  },
];

export const changelog = [
  {
    version: "v3.8.2",
    date: "2026-09-28",
    scope: "安卓 / 通用",
    notes: ["优化翻页流畅度与预加载速度", "修复部分机型离线缓存失败的问题", "新增双页阅读的横屏适配"],
  },
  {
    version: "v3.8.1",
    date: "2026-09-25",
    scope: "iOS",
    notes: ["适配最新 iOS 系统版本", "修复书架排序偶发错乱", "提升应用冷启动速度"],
  },
  {
    version: "v3.7.6",
    date: "2026-08-30",
    scope: "安卓 / iOS",
    notes: ["夜间模式新增暖色档位", "优化弱网环境下的页面加载", "修复已知闪退问题"],
  },
  {
    version: "v3.7.0",
    date: "2026-08-02",
    scope: "安卓 / iOS",
    notes: ["首页推荐布局全面改版", "支持书签分组管理", "提升离线缓存的稳定性"],
  },
];

export const faqs = [
  {
    q: "漫蛙官方客户端支持哪些系统？",
    a: "目前提供安卓版（Android 5.0 及以上）与 iOS 版（iOS 13.0 及以上），并针对平板大屏做了适配。不同系统的安装方式略有区别，请以页面对应版本的说明为准。",
  },
  {
    q: "下载的安装包无法安装怎么办？",
    a: "安卓设备请先在系统设置中允许当前来源安装应用，再重新点击安装包；若提示解析失败，通常是文件未下载完整，建议删除后重新下载一次。",
  },
  {
    q: "iOS 版和安卓版的功能有区别吗？",
    a: "核心的阅读、缓存与同步功能完全一致。iOS 版通过应用商店分发，更新更省心；安卓版安装包体积更小，安装方式更灵活。",
  },
  {
    q: "如何进行离线缓存？",
    a: "打开作品详情页，点击缓存入口并选择章节范围即可。建议在 Wi-Fi 环境下缓存，避免消耗移动流量，已缓存内容可在个人中心统一管理。",
  },
  {
    q: "换设备后阅读进度会丢失吗？",
    a: "登录同一账号后，书架与阅读进度会自动同步到云端。若未登录，记录仅保存在本机，卸载应用可能造成数据丢失。",
  },
  {
    q: "最新版和旧版本相比有哪些变化？",
    a: "最新版通常包含性能优化、阅读体验调整与问题修复，具体改动可以查看页面下方的版本更新记录，按需选择是否升级。",
  },
  {
    q: "安装时提示有风险或报毒是怎么回事？",
    a: "部分系统对非应用商店来源的程序会给出常规安全提醒。请务必从官方页面获取安装包，并在安装前核对版本号与文件大小。",
  },
];